import React from 'react';
import styled from 'styled-components';

interface StarProps {
  isActive: boolean;
  highlightOnMobile: boolean;
}

const StyledStar = styled.svg<{
  $isActive: boolean;
  $highlightOnMobile: boolean;
}>`
  width: 100%;
  fill: #eae9e5;
  stroke: #eae9e5;
  stroke-width: 1;
  transition-duration: ${({ theme }) => theme.transitionDuration};

  ${({ $isActive }) =>
    $isActive &&
    `
    fill: #ffd670;
    stroke: #efba33;
  `}

  ${({ $highlightOnMobile }) =>
    $highlightOnMobile &&
    `
    @media screen and (max-width: 768px) {
      fill: #ffd670;
      stroke: #efba33;
    }
  `}
`;

const Star: React.FC<StarProps> = ({ isActive, highlightOnMobile }) => {
  return (
    <StyledStar
      viewBox="0 0 60 60"
      version="1.1"
      $isActive={isActive}
      $highlightOnMobile={highlightOnMobile}
    >
      <path
        transform="translate(0, 2)"
        d="M59.4286423,21.9643119 C59.4286423,22.6071698 58.964356,23.2143134 58.5000697,23.6785997 L45.5357686,36.3214719 L48.6072008,54.178636 C48.6429151,54.4286363 48.6429151,54.6429223 48.6429151,54.8929226 C48.6429151,55.8214951 48.2143432,56.678639 47.1786277,56.678639 C46.6786271,56.678639 46.1786265,56.5000674 45.7500545,56.2500671 L29.7143211,47.8214856 L13.6785877,56.2500671 C13.2143015,56.5000674 12.7500152,56.678639 12.2500146,56.678639 C11.2142991,56.678639 10.7500128,55.8214951 10.7500128,54.8929226 C10.7500128,54.6429223 10.7857271,54.4286363 10.8214415,54.178636 L13.8928737,36.3214719 L0.892858207,23.6785997 C0.464286268,23.2143134 0,22.6071698 0,21.9643119 C0,20.892882 1.10714418,20.4643101 2.00000238,20.3214528 L19.9285952,17.7143068 L27.9643191,1.46428746 C28.285748,0.785715222 28.8928916,0 29.7143211,0 C30.5357507,0 31.1428943,0.785715222 31.4643232,1.46428746 L39.5000471,17.7143068 L57.4286399,20.3214528 C58.2857838,20.4643101 59.4286423,20.892882 59.4286423,21.9643119 Z"
      />
    </StyledStar>
  );
};

export default Star;
